import React, { useEffect } from 'react';
import * as Notifications from 'expo-notifications';
import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import 'react-native-gesture-handler';
// Telas
import LoginScreen from './src/screens/LoginScreen';
import RegisterCompany from './src/screens/RegisterCompany';
import RegisterMotoboy from './src/screens/RegisterMotoboy';
import CompanyOrderScreen from './src/screens/CompanyOrderScreen';
import MotoboyHomeScreen from './src/screens/MotoboyHomeScreen';
import GainsScreen from './src/screens/GainsScreen';
import MotoboyGainsScreen from './src/screens/MotoboyGainsScreen';
import GainsHistoryScreen from './src/screens/GainsHistoryScreen';
import DetailedGainsScreen from './src/screens/DetailedGainsScreen';
import CreateRouteScreen from './src/screens/CreateRouteScreen';
import RoutesScreen from './src/screens/RoutesScreen';
import RadarAnimation from './src/screens/RadarAnimation';
import ForgotPasswordScreen from './src/screens/ForgotPasswordScreen';
import SlideMenu from './src/screens/SlideMenu';
import Termos from './src/screens/Termos';
import Chat from './src/screens/Chat';
import DeleteAccountScreen from './src/screens/DeleteAccountScreen'; // ✅ Tela nova adicionada

// FlashMessage para notificações visuais
import FlashMessage, { showMessage } from 'react-native-flash-message';

const Stack = createNativeStackNavigator();

const App = () => {
  useEffect(() => {
    const setupNotifications = async () => {
      const token = await registerForPushNotificationsAsync();
      if (token) {
        console.log('Token registrado:', token);
      }
    };

    setupNotifications();

    const notificationListener = Notifications.addNotificationReceivedListener((notification) => {
      const { title, body } = notification.request.content;
      showMessage({
        message: title || 'Velox novo pedido!',
        description: body || '',
        type: 'info',
        duration: 4000,
      });
    });

    const responseListener = Notifications.addNotificationResponseReceivedListener((response) => {
      console.log('Interação com notificação:', response);
    });

    return () => {
      notificationListener.remove();
      responseListener.remove();
    };
  }, []);

  return (
    <>
      <NavigationContainer>
        <Stack.Navigator initialRouteName="LoginScreen">
          <Stack.Screen name="LoginScreen" component={LoginScreen} />
          <Stack.Screen name="RegisterCompany" component={RegisterCompany} />
          <Stack.Screen name="RegisterMotoboy" component={RegisterMotoboy} />
          <Stack.Screen name="CompanyOrderScreen" component={CompanyOrderScreen} />
          <Stack.Screen name="MotoboyHomeScreen" component={MotoboyHomeScreen} />
          <Stack.Screen name="GainsScreen" component={GainsScreen} />
          <Stack.Screen name="MotoboyGainsScreen" component={MotoboyGainsScreen} />
          <Stack.Screen name="CreateRouteScreen" component={CreateRouteScreen} />
          <Stack.Screen name="GainsHistoryScreen" component={GainsHistoryScreen} />
          <Stack.Screen 
            name="DetailedGainsScreen" 
            component={DetailedGainsScreen} 
            options={{
              title: 'Ganhos Detalhados',
              headerStyle: { backgroundColor: '#0f2027' },
              headerTintColor: '#fff',
              headerTitleStyle: { fontWeight: 'bold' },
            }} 
          />
          <Stack.Screen name="RoutesScreen" component={RoutesScreen} />
          <Stack.Screen name="RadarAnimation" component={RadarAnimation} />
          <Stack.Screen name="ForgotPasswordScreen" component={ForgotPasswordScreen} />
          <Stack.Screen name="SlideMenu" component={SlideMenu} />
          <Stack.Screen
            name="Termos"
            component={Termos}
            options={{
              title: 'Termos e Condições',
              headerStyle: { backgroundColor: '#0f2027' },
              headerTintColor: '#fff',
              headerTitleStyle: { fontWeight: 'bold' },
            }}
          />
          <Stack.Screen
            name="Chat"
            component={Chat}
            options={{
              title: 'Chat',
              headerStyle: { backgroundColor: '#0f2027' },
              headerTintColor: '#fff',
              headerTitleStyle: { fontWeight: 'bold' },
            }}
          />
          <Stack.Screen
            name="DeleteAccountScreen"
            component={DeleteAccountScreen}
            options={{
              title: 'Excluir Conta',
              headerStyle: { backgroundColor: '#0f2027' },
              headerTintColor: '#fff',
              headerTitleStyle: { fontWeight: 'bold' },
            }}
          />
        </Stack.Navigator>
      </NavigationContainer>

      <FlashMessage position="top" />
    </>
  );
};

async function registerForPushNotificationsAsync() {
  const { granted } = await Notifications.requestPermissionsAsync();
  if (!granted) {
    console.log('Permissão de notificação não concedida');
    return null;
  }

  const token = (await Notifications.getExpoPushTokenAsync()).data;
  return token;
}

export default App;
